const typeToColor = (str: string) => {
  let hash = 0;
  str.split("").forEach((char) => {
    hash = char.charCodeAt(0) + ((hash << 5) - hash);
  });
  let colour = "#";
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff;
    colour += value.toString(16).padStart(2, "0");
  }
  return colour;
};

export const getBehaviorColorCode = (type: string) => {
  if (type === null) return;
  switch (type.toLocaleLowerCase()) {
    case "sex":
      return "#613DC1";
    case "harassment":
    case "trolling":
      return "#FF5D22";
    case "intolerance":
      return "#EC00B4";
    case "community":
      return "#46B276";
    case "criminal":
      return "#bdc1cb";
    case "other drugs":
      return "#00AEEF";
    case "threat":
      return "#2B3B72";
    case "cannabis":
      return "#0000B4";
    case "violence":
      return "#FFCC3B";
    case "crime":
      return "#bdc1cb";
    default:
      return typeToColor(type);
  }
};
